import { useMemo, useState } from 'react'
import { useMedicalActsLicenseEnabled } from '@/features/medical-acts/model/useMedicalActsLicenseEnabled'
import { useLingui } from '@lingui/react'
import { t } from '@lingui/macro'
import PersonIcon from '@mui/icons-material/Person'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import PatientIdentityIcon from '@/components/ui/icons/PatientIdentity'
import ConsultationsIcon from '@/components/ui/icons/Consultations'
import ExpertisesIcon from '@/components/ui/icons/Expertises'

export function useSidebarMenuItems() {
  const lingui = useLingui()
  const hasMedicalActsLicense = useMedicalActsLicenseEnabled()

  const sidebarMenuItems = useMemo(
    () => [
      {
        id: 'patient-info' as const,
        icon: PatientIdentityIcon,
        label: lingui._(t`Patient information`),
      },
      {
        id: 'patient-consultations' as const,
        icon: ConsultationsIcon,
        label: lingui._(t`Patient consultations`),
      },
      {
        id: 'expertise' as const,
        icon: ExpertisesIcon,
        label: lingui._(t`Expertise`),
      },
      {
        id: 'attendees' as const,
        icon: PersonIcon,
        label: lingui._(t`Attendees`),
      },
      ...(hasMedicalActsLicense
        ? [{
          id: 'medical-acts' as const,
          icon: LocalHospitalIcon,
          label: lingui._(t`Medical Acts`),
        }]
        : []),
    ],
    [lingui, hasMedicalActsLicense]
  )

  const [selectedSidebarMenuItem, setSelectedSidebarMenuItem] = useState(sidebarMenuItems[0].id)

  return { sidebarMenuItems, selectedSidebarMenuItem, setSelectedSidebarMenuItem }
}

export type SidebarMenuItemId = ReturnType<typeof useSidebarMenuItems>['sidebarMenuItems'][number]['id']
